import React, { useState, useEffect, useCallback, Fragment } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import Breadcrumb from "../../common/breadcrumb";
import { global_actions, auth_actions } from "../../../redux-store";
import axios from "axios";

const RegisterBrand = () => {
  const { handleSubmit, register, errors, getValues } = useForm();

  const [paymentinfo, setPaymentinfo] = useState("paypal_account");
  const [info, setInfo] = useState({ ip: "" });

  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const history = useHistory();

  const URL = "https://ip.nf/me.json";
  useEffect(() => {
    axios.get(URL).then(({ data }) => {
      setInfo({ ...data });
    });
  }, []);
  useEffect(() => {
    if (user) {
      history.push("/");
    }
  }, [user]);

  const registerHandler = () => {
    let values = { ...getValues(), role: "brand" };
    if (values) {
      let brand = {
        ...values,
        ip_address: info.ip.ip,
        company_address: `${values.name}, ${values.city}, ${values.state} - ${values.zip}, ${values.country}`,
        [["paypal_account", "bank_routing"].filter(
          (i) => i !== paymentinfo
        )[0]]: undefined,
      };
      dispatch(auth_actions.register(brand));
    }
  };

  return (
    <>
      <div>
        <Breadcrumb title={"create account"} />
        {/*Regsiter section*/}
        <section className="register-page section-b-space">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h3>create account &mdash; Brand </h3>
                <div className="theme-card">
                  <form className="theme-form">
                    <div className="form-row">
                      <div className="col-md-4">
                        <label htmlFor="fname">First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="fname"
                          name="first_name"
                          placeholder="First Name"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                        />
                        <label htmlFor="fname" className="error">
                          {errors.first_name && errors.first_name.message}
                        </label>
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="mname">Middle Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="mname"
                          name="middle_name"
                          placeholder="Middle Name"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                        />
                        <label htmlFor="mname" className="error">
                          {errors.middle_name && errors.middle_name.message}
                        </label>
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="lname">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="lname"
                          name="last_name"
                          placeholder="Last Name"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                        />
                        <label htmlFor="lname" className="error">
                          {errors.last_name && errors.last_name.message}
                        </label>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-4">
                        <label htmlFor="email">Email</label>
                        <input
                          type="text"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Email"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                            pattern: {
                              value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                              message: "This must be a valid Email",
                            },
                          })}
                        />
                        <label htmlFor="email" className="error">
                          {errors.email && errors.email.message}
                        </label>
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="cell">Phone Number:</label>
                        <input
                          type="number"
                          className="form-control"
                          id="cell"
                          placeholder="Enter your number"
                          name="phone"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                        />
                        <label htmlFor="cell" className="error">
                          {errors.number && errors.number.message}
                        </label>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6">
                        <label htmlFor="password">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          placeholder="Enter your password"
                          name="password"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                            minLength: {
                              value: 8,
                              message:
                                "Password must have at least 8 characters",
                            },
                          })}
                        />
                        <label htmlFor="password" className="error">
                          {errors.password && errors.password.message}
                        </label>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="conf_password">Confirm Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="conf_password"
                          placeholder="Re-enter your password"
                          name="conf_password"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                            minLength: {
                              value: 8,
                              message:
                                "Password must have at least 8 characters",
                            },
                            validate: (v) =>
                              getValues().password === v ||
                              "Passwords are not same",
                          })}
                        />
                        <label htmlFor="conf_password" className="error">
                          {errors.conf_password && errors.conf_password.message}
                        </label>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6">
                        <label htmlFor="cname">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="cname"
                          name="company_name"
                          placeholder="Company Name"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                        />
                        <label htmlFor="cname" className="error">
                          {errors.company_name && errors.company_name.message}
                        </label>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="cweb">Company's Website</label>
                        <input
                          type="text"
                          className="form-control"
                          id="cweb"
                          name="website"
                          placeholder="Company's/Personal Website"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                        />
                        <label htmlFor="cweb" className="error">
                          {errors.website && errors.website.message}
                        </label>
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="col-md-6">
                        <label htmlFor="name">Street Address</label>
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Street Address"
                          ref={register({
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          })}
                        />
                        <label htmlFor="name" className="error">
                          {errors.name && errors.name.message}
                        </label>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="country">Country</label>
                        <input
                          type="text"
                          id="country"
                          name="country"
                          className="form-control"
                          placeholder="Country"
                          ref={register({
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          })}
                        />
                        <label htmlFor="country" className="error">
                          {errors.country && errors.country.message}
                        </label>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6">
                        <label htmlFor="city">City</label>
                        <input
                          type="text"
                          id="city"
                          name="city"
                          className="form-control"
                          placeholder="City"
                          ref={register({
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          })}
                        />

                        <label htmlFor="city" className="error">
                          {errors.city && errors.city.message}
                        </label>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="state">State</label>
                        <input
                          className="form-control"
                          ref={register({
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          })}
                          type="text"
                          id="state"
                          name="state"
                          placeholder="State"
                        />
                        <label htmlFor="state" className="error">
                          {errors.state && errors.state.message}
                        </label>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6">
                        <label htmlFor="zip">Zip</label>
                        <input
                          className="form-control"
                          type="text"
                          id="zip"
                          name="zip"
                          placeholder="Zip"
                          ref={register({
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                            pattern: {
                              value: /^[\d]+$/,
                              message: "This field must be a number",
                            },
                          })}
                        />
                        <label htmlFor="zip" className="error">
                          {errors.zip && errors.zip.message}
                        </label>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6">
                        <label htmlFor="broute">Receive Payments Via</label>
                        <div className="d-flex justify-content-start mt-3">
                          <input
                            type="radio"
                            className="form-control w-auto mx-5"
                            id="broute"
                            name="paypal_broute"
                            value="paypal_account"
                            checked={paymentinfo === "paypal_account"}
                            onChange={(e) => setPaymentinfo(e.target.value)}
                          />
                          <p>Paypal Account</p>
                        </div>
                        <div className="d-flex justify-content-start">
                          <input
                            type="radio"
                            className="form-control w-auto mx-5"
                            id="broute"
                            name="paypal_broute"
                            value="bank_routing"
                            checked={paymentinfo === "bank_routing"}
                            onChange={(e) => setPaymentinfo(e.target.value)}
                          />
                          <p>Bank's Routing Number</p>
                        </div>
                      </div>
                      {paymentinfo === "paypal_account" ? (
                        <div className="col-md-6">
                          <label htmlFor="paypinfo">Paypal Email</label>
                          <input
                            type="text"
                            className="form-control"
                            id="paypinfo"
                            name="paypal_account"
                            placeholder="Paypal Email"
                            ref={register({
                              required: {
                                value: true,
                                message: "This Field is Required",
                              },
                              pattern: {
                                value: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
                                message: "This must be a valid Email",
                              },
                            })}
                          />
                          <label htmlFor="paypinfo" className="error">
                            {errors.paypal_account &&
                              errors.paypal_account.message}
                          </label>
                        </div>
                      ) : (
                        <div className="col-md-6">
                          <label htmlFor="brouting">Bank's Routing No.</label>
                          <input
                            type="number"
                            className="form-control"
                            id="brouting"
                            name="bank_routing"
                            placeholder="Bank's Routing Number"
                            ref={register({
                              required: {
                                value: true,
                                message: "This Field is Required",
                              },
                              valueAsNumber: true,
                            })}
                          />
                          <label htmlFor="brouting" className="error">
                            {errors.bank_routing && errors.bank_routing.message}
                          </label>
                        </div>
                      )}
                    </div>
                    <div className="form-row">
                      <a
                        href="#"
                        className="btn btn-solid"
                        onClick={handleSubmit(registerHandler)}
                      >
                        Create Account
                      </a>
                      <Link
                        className="btn btn-light d-flex align-items-center"
                        to="/login"
                      >
                        Already have an Account?
                      </Link>
                      <Link to="/contact" className="ml-2 mt-4">
                        Need help?
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RegisterBrand;
